"use client";

// Library Imports
import React from "react";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faAnglesRight } from "@fortawesome/free-solid-svg-icons";
// import UpdatedHeader from "@/components/common/UpdatedHeader";
import HealthcareFooter from "@/components/common/healthcareFooter";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";

const MobilePage = () => {
  return (
    <main className="flex flex-col items-center justify-between bg-white min-h-screen">
      <div className="bg-[#191919] w-full blue_shadow">
        <GlobalHeaderNew />
      </div>
      <div className="mx-auto w-full square_grid_bg">
        <div className="lg:container mx-auto 2xl:px-0 10 md:px-5 lg:px-5">
          <div className="mx-auto lg:p-0 min-h-screen">
            <div className="term-sec relative md:top-[40px] top-7 z-20 lg:text-left md:text-left mb-[50px]">
              <h1 className="lg:text-[36px] md:text-[38px] mb-3 font-semibold lg:leading-[3.5rem] md:leading-[3rem] leading-[1.8rem] text-[#0C1F33] text-center">
                <span className="md:pb-0 inline-block border-[#ca7216] md:border-b-[4px] border-b-2 ml-2">
                  Cookie policy
                </span>
              </h1>
              <ul className="pt-[10px] mb-[74px] lg:px-0 px-[15px]">
                <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                  <div className="inline-flex">
                    <FontAwesomeIcon
                      className="md:pr-[10px] md:pt-[6px] pr-[10px] pt-[5px] text-[12px] text-[#0043b8]"
                      icon={faCircle}
                    />
                    <div className="">
                      <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                        Introduction
                      </p>
                      <p>
                        Miles Education (&quot;we,&quot; &quot;us,&quot;
                        &quot;our&quot;) uses cookies and similar technologies
                        to enhance your experience on our website,{" "}
                        <a className="text-[#5b6efd]" href="/">
                          www.mileseducation.com
                        </a>{" "}
                        (the &quot;Site&quot;). This Cookie Policy explains what
                        cookies are, how we use them, your choices regarding
                        cookies, and further information about cookies.
                      </p>
                    </div>
                  </div>
                </li>

                <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                  <div className="inline-flex">
                    <FontAwesomeIcon
                      className="md:pr-[10px] md:pt-[6px] pr-[10px] pt-[5px] text-[12px] text-[#0043b8]"
                      icon={faCircle}
                    />
                    <div className="">
                      <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                        What Are Cookies?{" "}
                      </p>
                      <p>
                        Cookies are small text files that are stored on your
                        device (computer, smartphone, tablet) when you visit a
                        website. They help the website recognize your device on
                        subsequent visits, enabling a more tailored experience.
                      </p>
                    </div>
                  </div>
                </li>

                <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                  <div className="inline-flex">
                    <FontAwesomeIcon
                      className="md:pr-[10px] md:pt-[6px] pr-[10px] pt-[5px] text-[12px] text-[#0043b8]"
                      icon={faCircle}
                    />
                    <div className="">
                      <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                        Types of Cookies We Use{" "}
                      </p>
                      <p>We use the following types of cookies on our Site:</p>
                      <ul className="pl-[15px]">
                        <li className="pb-[8px]">
                          <div className="inline-flex">
                            <FontAwesomeIcon
                              className="md:text-[16px] text-xs text-[#0043b8] pr-[5px] md:pt-[5px] pt-[2px] font-bold"
                              icon={faAnglesRight}
                            />
                            <p>
                              <b>Essential Cookies: </b>These cookies are
                              necessary for the operation of our Site. They
                              enable you to navigate the Site and use its
                              features, such as accessing secure areas.
                            </p>
                          </div>
                        </li>
                        <li className="pb-[8px]">
                          <div className="inline-flex">
                            <FontAwesomeIcon
                              className="md:text-[16px] text-xs text-[#0043b8] pr-[5px] md:pt-[5px] pt-[2px] font-bold"
                              icon={faAnglesRight}
                            />
                            <p>
                              <b>Performance and Analytics Cookies: </b> These
                              cookies help us understand how visitors interact
                              with our Site by collecting information
                              anonymously. This data helps us improve the
                              website's functionality and performance.
                            </p>
                          </div>
                        </li>
                        <li className="pb-[8px]">
                          <div className="inline-flex">
                            <FontAwesomeIcon
                              className="md:text-[16px] text-xs text-[#0043b8] pr-[5px] md:pt-[5px] pt-[2px] font-bold"
                              icon={faAnglesRight}
                            />
                            <p>
                              <b>Functional Cookies: </b> These cookies allow
                              our Site to remember choices you make, such as
                              your language or region, to provide a more
                              personalized experience.
                            </p>
                          </div>
                        </li>
                        <li className="pb-[8px]">
                          <div className="inline-flex">
                            <FontAwesomeIcon
                              className="md:text-[16px] text-xs text-[#0043b8] pr-[5px] md:pt-[5px] pt-[2px] font-bold"
                              icon={faAnglesRight}
                            />
                            <p>
                              <b>Targeting and Advertising Cookies: </b>These
                              cookies are used to deliver advertisements
                              relevant to you and your interests. They also
                              limit the number of times you see an ad and
                              measure the effectiveness of advertising
                              campaigns.
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>

                <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                  <div className="inline-flex">
                    <FontAwesomeIcon
                      className="md:pr-[10px] md:pt-[6px] pr-[10px] pt-[5px] text-[12px] text-[#0043b8]"
                      icon={faCircle}
                    />
                    <div className="">
                      <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                        How We Use Cookies{" "}
                      </p>
                      <p>We use cookies for various purposes, including:</p>
                      <ul className="pl-[15px]">
                        <li className="pb-[8px]">
                          <div className="inline-flex">
                            <FontAwesomeIcon
                              className="md:text-[16px] text-xs text-[#0043b8] pr-[5px] md:pt-[5px] pt-[2px] font-bold"
                              icon={faAnglesRight}
                            />
                            <p>To ensure the proper functioning of our Site.</p>
                          </div>
                        </li>
                        <li className="pb-[8px]">
                          <div className="inline-flex">
                            <FontAwesomeIcon
                              className="md:text-[16px] text-xs text-[#0043b8] pr-[5px] md:pt-[5px] pt-[2px] font-bold"
                              icon={faAnglesRight}
                            />
                            <p>
                              To analyze and improve the performance of our
                              Site.
                            </p>
                          </div>
                        </li>
                        <li className="pb-[8px]">
                          <div className="inline-flex">
                            <FontAwesomeIcon
                              className="md:text-[16px] text-xs text-[#0043b8] pr-[5px] md:pt-[5px] pt-[2px] font-bold"
                              icon={faAnglesRight}
                            />
                            <p>
                              To remember your preferences and personalize your
                              experience.
                            </p>
                          </div>
                        </li>
                        <li className="pb-[8px]">
                          <div className="inline-flex">
                            <FontAwesomeIcon
                              className="md:text-[16px] text-xs text-[#0043b8] pr-[5px] md:pt-[5px] pt-[2px] font-bold"
                              icon={faAnglesRight}
                            />
                            <p>
                              To deliver targeted advertising and measure the
                              effectiveness of our marketing efforts.
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>

                <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                  <div className="inline-flex">
                    <FontAwesomeIcon
                      className="md:pr-[10px] md:pt-[6px] pr-[10px] pt-[5px] text-[12px] text-[#0043b8]"
                      icon={faCircle}
                    />
                    <div className="">
                      <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                        Your Choices Regarding Cookies
                      </p>
                      <p>
                        You have the option to accept or reject cookies. Most
                        web browsers automatically accept cookies, but you can
                        usually modify your browser settings to decline cookies
                        if you prefer. However, please note that disabling
                        cookies may affect the functionality of our Site.
                      </p>
                      <p>
                        To manage your cookie preferences, you can adjust your
                        browser settings or use the cookie management tools
                        available on our Site.
                      </p>
                    </div>
                  </div>
                </li>

                <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                  <div className="inline-flex">
                    <FontAwesomeIcon
                      className="md:pr-[10px] md:pt-[6px] pr-[10px] pt-[5px] text-[12px] text-[#0043b8]"
                      icon={faCircle}
                    />
                    <div className="">
                      <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                        Third-Party Cookies
                      </p>
                      <p>
                        We may also use third-party cookies provided by trusted
                        partners for analytics and advertising purposes. These
                        cookies are subject to the privacy policies of the
                        respective third parties.
                      </p>
                    </div>
                  </div>
                </li>

                <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                  <div className="inline-flex">
                    <FontAwesomeIcon
                      className="md:pr-[10px] md:pt-[6px] pr-[10px] pt-[5px] text-[12px] text-[#0043b8]"
                      icon={faCircle}
                    />
                    <div className="">
                      <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                        {" "}
                        Changes to This Cookie Policy
                      </p>
                      <p>
                        We may update this Cookie Policy from time to time to
                        reflect changes in our practices or legal requirements.
                        We encourage you to review this policy periodically to
                        stay informed about how we use cookies.
                      </p>
                    </div>
                  </div>
                </li>

                <li className="text-[#212529] md:text-[18px] text-xs pt-[25px] md:leading-7">
                  <div className="inline-flex">
                    <FontAwesomeIcon
                      className="md:pr-[10px] md:pt-[6px] pr-[10px] pt-[5px] text-[12px] text-[#0043b8]"
                      icon={faCircle}
                    />
                    <div className="">
                      <p className="md:text-[22px] text-base font-semibold mb-[10px]">
                        {" "}
                        Contact Us
                      </p>
                      <p>
                        If you have any questions about our use of cookies or
                        this Cookie Policy, please contact us at:
                      </p>
                      <p>
                        <b>Miles Education</b>
                      </p>
                      <p>
                        Email:{" "}
                        <a
                          className="text-[#5b6efd]"
                          href="mailto:info@mileseducation.com"
                        >
                          info@mileseducation.com
                        </a>
                      </p>
                      <p>
                        Phone:{" "}
                        <a className="text-[#5b6efd]" href="tel:8929942032">
                          +91-8929942032
                        </a>
                      </p>
                      <p>
                        Address: 2nd Floor,Mantri Avenue,Koramangala 8th Block,
                        Bangalore - 560047
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="mx-auto w-full h-auto xl:px-0 px-5 relative">
        <div className=" text-[#030F1C] z-0">
          <AboutUsFooter />
        </div>
      </div> */}
      <div className="mx-auto w-full h-[auto] md:h-[auto] xl:px-0 md:px-6 lg:!px-6 px-5 relative square_grid_bg pb-0">
        <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 text-[#030F1C] z-[0]">
          <div className="md:w-[95%] 2xl-w-full mx-auto">
            <HealthcareFooter />
          </div>
        </div>
      </div>
    </main>
  );
};
export default MobilePage;
